import {objectFromEntries} from '@benchling/js-utils';

import {DataFrame, DataFrameColumnDef} from 'data-frames/DataFrameTypes';

import isSystemColumn from './isSystemColumn';

/**
 * Return a data frame that only includes the columns that pass the predicate callback.
 */
export default function filterColumns(
  dataFrame: DataFrame,
  predicate: (column: DataFrameColumnDef, index: number) => boolean
): DataFrame {
  const remainingColumns = dataFrame.columns.filter(
    (column, index) => predicate(column, index) || isSystemColumn(column)
  );
  const remainingColumnSystemNames = remainingColumns.map((column) => column.systemName);
  return {
    ...dataFrame,
    columns: remainingColumns,
    rows: dataFrame.rows.map((row) =>
      objectFromEntries(
        Object.entries(row).filter(([columnName]) => remainingColumnSystemNames.includes(columnName))
      )
    ),
  };
}
